import tvProxyInterceptor from './tvproxy';
import tvH5ProxyInterceptor from './tvh5proxy';
import tvSecurityHandler from './tvsecurity-handler';
import loginExpiredHandler from './login-expired-handler';
import { isTVPage, isTVH5Page } from './utils';

const beforeMagicRequest = (req) => {
  console.log(`request config: ${JSON.stringify(req)}`);
  const request = req;
  if (isTVH5Page()) {
    // 从TV上扫码下来的场景，会带登录态(以o_开头的参数，在登录插件中，存入了cookie中), 请求时把这些参数透传给后端
    return tvH5ProxyInterceptor(request);
  }
  if (isTVPage()) {
    return tvProxyInterceptor(request);
  }
  return request;
};

const afterMagicResponse = async (response, request) => {
  if (isTVPage()) {
    try {
      return tvSecurityHandler(response, request);
    } catch (err) {
      console.error(err);
    }
  }
  await loginExpiredHandler(response);
  return response;
};

export { beforeMagicRequest, afterMagicResponse };
